import { z } from 'zod';

import { ApiVonaZod } from './ApiVona';

export const GetCurrentVonaResponseZod = z.object({
  vona: ApiVonaZod,
});
